var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriptionPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.75 4c0-.729-.29-1.429-.805-1.945A2.755 2.755 0 0 0 18 1.25H6c-.729 0-1.429.29-1.945.805A2.755 2.755 0 0 0 3.25 4v16c0 .729.29 1.429.805 1.945A2.755 2.755 0 0 0 6 22.75h12c.729 0 1.429-.29 1.945-.805A2.755 2.755 0 0 0 20.75 20zm-1.5 0v16A1.252 1.252 0 0 1 18 21.25H6A1.252 1.252 0 0 1 4.75 20V4A1.252 1.252 0 0 1 6 2.75h12A1.252 1.252 0 0 1 19.25 4z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.75A.75.75 0 0 0 15 5H9a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h6a.75.75 0 0 0 .75-.75zm-1.5.75V8h-4.5V6.5zM10.75 15.25a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75zm-1.5.75v1.5h-1.5V16zM17.75 15.25a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75zm-1.5.75v1.5h-1.5V16z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.75v3.5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-1.5 0z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 15.25V13h5.5v2.25a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75h-7a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionPlan);
export default __webpack_public_path__ + "static/media/subscription-plan.b4c0836efc2c2de6e076772fac1dec48.svg";
export { ForwardRef as ReactComponent };